// src/hooks/useSeasonalMeanSeries.ts
import { useMemo } from "react";
import useFetchGraphData from "../useFetchGraphData";

export default function useSeasonalMeanSeries({
  parameterid,
  startYear,
  endYear,
}) {
  const {
    data,
    isFetching: isLoading,
    isError,
  } = useFetchGraphData(
    { parameterid, start_year: startYear, end_year: endYear },
    "avg-yearly-standard-graph"
  );

  const out = useMemo(() => {
    if (!data?.length)
      return { raw: [], series: [], unit: "", isLoading, isError };

    return {
      raw: data,
      //                ▼── centre dot on 30 Jun of the same year
      series: data.map((d) => {
        const yr = new Date(d.date_time).getFullYear();
        return {
          date: new Date(yr, 0, 1), // ← Jan 1 of that year
          value: d.rvalue,
        };
      }),

      unit: data[0].unit_name,
    };
  }, [data, isLoading, isError]);

  return { ...out, isLoading, isError };
}
